module.exports = __webpack_public_path__ + "img/errorLatest.bed123af.png";